console.log('js/survey_closer.js -> v0.1.0');

$(function() {
	$('#survey-close_5, #make-survey_5').click(function() {
		$.post( "/close_survey_5", function( data ) { });
	});
});

$(function() {
	$('[data-warning]').each(function() {
		var id = $(this).attr('data-warning');
		var cookie = Number(Cookies.get('warning-'+id)) || 0;
		if(cookie < 3){
			$(this).css('display','block');
			Cookies.set('warning-'+id,cookie+1);
		};
	});
	$('[data-warning] .close').unbind();
	$('[data-warning] .close').click(function() {
		console.log('close');
		var id = $(this).closest('[data-warning]').attr('data-warning');
		Cookies.set('warning-'+id,99);
		$(this).closest('[data-warning]').remove();
	});
});
